export default "__VITE_ASSET__CSA1tBFn__"